class InvoicesCtrl {
  constructor(Authentication, AccountService, PrintService, Restangular, $scope, invoices) {
    'ngInject';

    Object.assign(this, {
      Authentication,
      AccountService,
      PrintService,
      Restangular,
      $scope,
      invoices,
    });

    this.invoices = this.invoices.filter((i) => i.paid);

    $scope.$on('socket:invoice:new', (event, invoice) => {
      if (
        invoice.paid &&
        !this.invoices.find((inv) => inv.invoiceNumber === invoice.invoiceNumber)
      ) {
        this.Restangular.restangularizeElement(null, invoice, 'account/org/invoices');
        this.invoices.unshift(invoice);
      }
    });
  }

  print(invoice) {
    this.PrintService.printInvoice(invoice.id);
  }
}

export default InvoicesCtrl;
